<template>
    <rounded-dialog
        :model="model"
        title="Atualização em Massa de Validade de Tarifas"
        :no-icon="true"
    >
        <template v-slot:body>
            <p class="text-start color-grey-onfly font-weight-bold">
                Escolha os tipos de tarifas a serem atualizadas:
            </p>
            <v-form ref="form">
                <v-row>
                    <v-col>
                        <v-checkbox
                            v-model="selectedFareTypes"
                            label="Vigentes"
                            value="nonExpired"
                            class="mx-auto"
                            :rules="selectedFareTypesRules"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-model="selectedFareTypes"
                            label="A Expirar"
                            value="aboutToExpire"
                            class="mx-auto"
                            :rules="selectedFareTypesRules"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-model="selectedFareTypes"
                            label="Expiradas"
                            value="expired"
                            class="mx-auto"
                            :rules="selectedFareTypesRules"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <span
                        class="ml-4 mt-2 red--text"
                        v-if="selectedFareTypesHaveValidationError"
                    >
                    É obrigatório selecionar pelo menos um tipo de tarifa.
                </span>
                </v-row>
                <p class="text-start color-grey-onfly my-8 pt-2 font-weight-bold">
                    Escolha a data de validade a ser aplicada:
                </p>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="visibleExpirationDate"
                                    label="Validades das tarifas"
                                    outlined
                                    readonly
                                    :rules="visibleExpirationDateRules"
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="expirationDate"
                                locale="pt-BR"
                                :first-day-of-week="1"
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-form>
        </template>
        <template v-slot:actions>
            <v-btn text color="grey darken-1" @click="close">Fechar</v-btn>
            <v-btn color="primary" depressed @click="openConfirmationModal()">
                Atualizar
            </v-btn>
        </template>
    </rounded-dialog>
</template>

<script>
import RoundedDialog from "./RoundedDialog.vue";
import {formatDateTimeIntoDate, getTodayDatePlusOneYear} from "../../helpers/DateHelper";
import ConfirmActionDialog from "./ConfirmActionDialog.vue";

export default {
    name: "FareExpirationDateMassUpdateDialog",
    components: {
        ConfirmActionDialog,
        RoundedDialog
    },
    props: {
        model: {
            type: Boolean,
            default: false
        },
        executeMassUpdate: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        valid: false,
        expirationDate: null,
        selectedFareTypes: [],
        selectedFareTypesRules: [
            v => !!(v && v.length) || ''
        ],
        selectedFareTypesIsEmptyForInitialization: true,
        visibleExpirationDateRules: [
            v => !!v || 'A data de validade das tarifas é obrigatória',
        ],
    }),
    computed: {
        isEmptyExpirationDateFareTypesForUpdate () {
            return this.selectedFareTypes.length === 0;
        },
        selectedFareTypesHaveValidationError () {
            return this.isEmptyExpirationDateFareTypesForUpdate &&
                !this.selectedFareTypesIsEmptyForInitialization;
        },
        visibleExpirationDate () {
            if (this.expirationDate === null) { return null; }
            return formatDateTimeIntoDate(this.expirationDate);
        },
        hotelId () {
            return this.$route.params.id;
        }
    },
    methods: {
        validate() {
            this.removeFareTypesIsEmptyForInitialization();
            return this.$refs.form.validate();
        },
        open () {
            this.model = true;
        },
        close () {
            this.$emit('close');
            this.$emit('update:model', false);
        },
        massUpdateFareExpirationDate () {
            if (!this.validate()) { return; }

            axios.put(
                '/api/fares/expiration-date-mass-update',
                this.getData(),
                { validateStatus: () => true }
            ).then((response) => {
                response.data.success
                    ? this.onMassUpdateSuccess(response)
                    : this.onMassUpdateError(response);
            });
        },
        removeFareTypesIsEmptyForInitialization () {
            if (this.selectedFareTypesIsEmptyForInitialization) {
                this.selectedFareTypesIsEmptyForInitialization = false;
            }
        },
        getData () {
            return {
                hotelId: this.hotelId,
                fareStatus: this.selectedFareTypes,
                expirationDate: this.expirationDate
            };
        },
        openConfirmationModal () {
            if (!this.validate()) { return; }
            this.$emit('open-mass-update-confirmation-modal');
        },
        onMassUpdateSuccess (response) {
            const responseData = this.formatResponseData('success', response.data.message);
            this.$emit('got-mass-update-response', responseData);
        },
        onMassUpdateError (response) {
            const responseData = this.formatResponseData('error', response.data.message);
            this.$emit('got-mass-update-response', responseData);
        },
        formatResponseData (type, message) {
            return {
                type: type,
                message: message
            };
        }
    },
    created () {
        this.expirationDate = getTodayDatePlusOneYear();
    },
    watch: {
        selectedFareTypes (value) {
            this.removeFareTypesIsEmptyForInitialization();
        },
        executeMassUpdate (value) {
            if (value === true) {
                this.close();
                this.massUpdateFareExpirationDate();
            }
        }
    }
}
</script>

<style scoped>

</style>
